





















import Vue from "vue";
import Navigation from "@/components/Navigation.vue";

export default Vue.extend({
  name: "App",
  components: { Navigation },
  data() {
    return {
      drawer: true,
      items: [
        { title: "Home", icon: "dashboard" },
        { title: "About", icon: "question_answer" }
      ],
      right: null,
      envTitle: process.env.VUE_APP_ENV_TITLE as string
    };
  }
});
